import { render, staticRenderFns } from "./RepairParts.vue?vue&type=template&id=528c31d8&scoped=true"
import script from "./RepairParts.vue?vue&type=script&lang=js"
export * from "./RepairParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c31d8",
  null
  
)

export default component.exports